import { DSTeamMember, LinkedLinkProps } from 'shared-definitions/types'
import { nullableString } from 'shared-code/conversion'
import { ApiTeamMemberProps } from 'data-source/types.wp'
import { imageMapper } from 'data-source/mappers/imageMapper'
import { PLinkMapperOpts } from 'data-source/mappers/pLinkMapper'
import { socialsMapper } from 'data-source/mappers/socialsMapper'

export interface TeamMemberMapperOpts extends PLinkMapperOpts {
  authorLinkBuilder: (slug: string) => LinkedLinkProps
  contactLinkBuilder: (message: string) => LinkedLinkProps
}

export function teamMemberMapper(
  input: ApiTeamMemberProps,
  opts: TeamMemberMapperOpts
): DSTeamMember {
  return {
    slug: input.slug,
    pLink: opts.authorLinkBuilder(input.slug),
    name: input.name,
    image: imageMapper(input.image, opts),
    position: input.position,
    description: nullableString(
      Array.isArray(input.description) ? input.description.join(' ') : input.description
    ),
    socials: [
      ...socialsMapper(input.socials),
      {
        title: 'Email',
        pLink: opts.contactLinkBuilder(`Directed to ${input.name}`),
        icon: 'email',
      },
    ],
  }
}
